import { TooltipPosition } from '@angular/material/tooltip';

import { SnTooltipDisableExpression } from './tooltip-disable-expression.type';

interface ISnTooltipConfig {
  message: string;
  position?: TooltipPosition;
  showDelay?: number;
  hideDelay?: number;
  disabled?: boolean | SnTooltipDisableExpression;
}

export type SnTooltipConfig = string | ISnTooltipConfig;
